import { useReducerContext } from '@bbt/react-components';
import InitStatus from './init-status';

const [Provider, Contexts] = useReducerContext({ InitStatus });

export { Provider, Contexts };
